mutation ResetPasswordApplyMutation($input: ResetPasswordApplyInput!) {
  resetPasswordApply(input: $input) {
    user {
      id
    }
    authentificationToken
  }
}
